module.exports = __webpack_public_path__ + "img/hudong.b558d04d.png";